export interface FlashMessageGenerateTokenDto
{
    getMsisdn():string;
    getAccessToken(): string;

    setMsisdn(msisdn:string):void;
    setAccessToken(token: string): void;
}

export class FlashMessageGenerateTokenDtoImpl implements FlashMessageGenerateTokenDto
{
    private msisdn:string;
    private accessToken: string;
 
    getMsisdn(): string 
    {
        return this.msisdn;
    }
  
    setMsisdn(msisdn: string): void 
    {
        this.msisdn = msisdn;
    }
    
    getAccessToken(): string {
       return this.accessToken;
    }
    setAccessToken(token: string): void {
        this.accessToken = token;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessagegenereratetoken/flashmessagegeneratetoken.tsx